document.addEventListener("DOMContentLoaded", async () => {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.log(
      "%c cartUpdate event triggered ",
      "background: #0070f3; color: white; font-size: 14px; padding: 3px 12px; border-radius: 4px;"
    );
    onCartUpdate(event);
  });

  const extractVariantIdFromGID = (gid) => {
    const match = gid.match(/gid:\/\/shopify\/ProductVariant\/(\d+)/);
    return match ? match[1] : gid;
  };

  async function updateCartVariantQuantity(variantId, quantity, variantInCart) {
    if (quantity === 0) {
      // Use remove always
      return await removeCartVariant(variantId);
    }
    if (variantInCart?.[variantId]?.quantity > 0) {
      // Already in cart → use /cart/change.js to set quantity
      return await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity }),
      });
    } else {
      // Not in cart → use /cart/add.js to add with the right quantity
      return await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });
    }
  }

  async function removeCartVariant(variantId) {
    return await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 0 }),
    });
  }

  // Helper: Compare two cart arrays (expected vs. final)
  function compareCartJSON(expected, final) {
    function itemKey(item) {
      return `${item.variantId}`;
    }
    const diffs = [];
    const finalMap = new Map(final.map(item => [itemKey(item), item]));
    const expectedMap = new Map(expected.map(item => [itemKey(item), item]));
    // Items in expected but changed in final
    expected.forEach(exp => {
      const fin = finalMap.get(itemKey(exp));
      if (!fin) {
        diffs.push({ type: "removed", expected: exp });
      } else {
        const changes = {};
        for (const key in exp) {
          if (JSON.stringify(exp[key]) !== JSON.stringify(fin[key])) {
            changes[key] = { expected: exp[key], final: fin[key] };
          }
        }
        if (Object.keys(changes).length) {
          diffs.push({
            type: "changed",
            variantId: exp.variantId,
            changes,
            expected: exp,
            final: fin
          });
        }
      }
    });
    // Items in final but not in expected (added)
    final.forEach(fin => {
      if (!expectedMap.has(itemKey(fin))) {
        diffs.push({ type: "added", final: fin });
      }
    });
    return diffs;
  }

  const onCartUpdate = async function (event) {
    
    const cartItemsEl = document.querySelector('cart-items');
    if(!event?.line && cartItemsEl && typeof cartItemsEl.enableLoading === 'function') {
      cartItemsEl.enableLoading(1);
    }
    // Trigger loading overlay for cart line 1
    // const cartItemsEl = document.querySelector('cart-items');
    // if (cartItemsEl && typeof cartItemsEl.enableLoading === 'function') {
    //   cartItemsEl.enableLoading(event.line); // Replace 1 with your desired line number
    // }

    const cart = await fetch(`${routes.cart_url}?section_id=main-cart-items`);
    const cartText = await cart.text();
    const cartHtml = new DOMParser().parseFromString(cartText, 'text/html');
    const cartItems = Array.from(cartHtml.querySelectorAll('.cart-item'));

    // --- INPUT OBJECT DEBUG ---
    const inputObject = cartItems.map(item => ({
      variantId: extractVariantIdFromGID(item.dataset.variantGid),
      quantity: parseInt(item.dataset.quantity || "0"),
      additionalFee: item.dataset.productAdditionalFee,
      craftingFee: item.dataset.productCraftingFee,
      isFee: item.dataset.isFee
    }));
    console.log(
      "%c Input object (raw DOM data):",
      "background: #818cf8; color: #fff; font-size: 13px; padding: 2px 10px; border-radius: 3px;"
    );
    console.log(inputObject);

    // Build variant-in-cart map
    const feeVariantInCart = {};
    cartItems.forEach(item => {
      const variantId = extractVariantIdFromGID(item.dataset.variantGid);
      const quantity = parseInt(item.dataset.quantity || "0");
      if (variantId) {
        feeVariantInCart[variantId] = { quantity };
      }
    });

    let cartModified = false;
    let cartDebugReasons = [];
    let hasNonFeeProductWithFee = false;
    const feeVariantGIDs = new Set();
    const allFeeVariantsInUse = new Set();

    // --- Aggregate all possible fee variant IDs and cap IDs for removal logic
    cartItems.forEach(item => {
      const additionalFee = item.dataset.productAdditionalFee && item.dataset.productAdditionalFee !== "null"
        ? JSON.parse(item.dataset.productAdditionalFee)
        : null;
      const craftingFee = item.dataset.productCraftingFee && item.dataset.productCraftingFee !== "null"
        ? JSON.parse(item.dataset.productCraftingFee)
        : null;

      if (additionalFee) {
        hasNonFeeProductWithFee = true;
        const regularId = extractVariantIdFromGID(additionalFee.fee_product_variant);
        const capId = extractVariantIdFromGID(additionalFee.fee_product_variant_cap_);
        feeVariantGIDs.add(regularId);
        feeVariantGIDs.add(capId);
        allFeeVariantsInUse.add(regularId);
        allFeeVariantsInUse.add(capId);
      }
      if (craftingFee) {
        hasNonFeeProductWithFee = true;
        const regularId = extractVariantIdFromGID(craftingFee.fee_product_variant);
        feeVariantGIDs.add(regularId);
        allFeeVariantsInUse.add(regularId);
        if (craftingFee.fee_product_variant_cap_) {
          const capId = extractVariantIdFromGID(craftingFee.fee_product_variant_cap_);
          feeVariantGIDs.add(capId);
          allFeeVariantsInUse.add(capId);
        }
      }
    });


    // --- MAN-POWER FEE LOGIC (ENSURE ONLY ONE FEE PRODUCT) ---
    let manPowerVariantId = null;
    let manPowerFeeNeeded = false;

    // Check if there is any product in the cart that requires Man-power Fee
    cartItems.forEach(item => {
      if (item.dataset.productManPower && item.dataset.productManPower !== "null") {
        try {
          const manPowerData = JSON.parse(item.dataset.productManPower);
          if (manPowerData && manPowerData.id) {
            manPowerVariantId = String(manPowerData.id);
            manPowerFeeNeeded = true;
          }
        } catch (e) {}
      }
    });

    if (manPowerVariantId) {
      // Count how many fee items with this variantId are currently in the cart
      const feeInCartQty = cartItems
        .filter(item => String(item.dataset.variantGid) === manPowerVariantId)
        .reduce((sum, item) => sum + parseInt(item.dataset.quantity || "0"), 0);

      if (manPowerFeeNeeded) {
        // If the fee is needed but the quantity is not exactly 1, update it to 1
        if (feeInCartQty !== 1) {
          await updateCartVariantQuantity(manPowerVariantId, 1, feeVariantInCart);
          cartModified = true;
          cartDebugReasons.push(`Set Man-power Fee (id: ${manPowerVariantId}) to quantity 1`);
        }
      } else {
        // If the fee is not needed but it exists in the cart, remove it
        if (feeInCartQty > 0) {
          await removeCartVariant(manPowerVariantId);
          cartModified = true;
          cartDebugReasons.push(`Remove Man-power Fee (id: ${manPowerVariantId})`);
        }
      }
    }    

    // Remove orphaned fee items (but not real products)
    for (const item of cartItems) {
      const isFeeItem = item.dataset.isFee === 'true';
      const variantId = extractVariantIdFromGID(item.dataset.variantGid);

      // --- Skip removal if this is Man-power Fee ---
      if (variantId === manPowerVariantId) continue;
      
      if (isFeeItem && !allFeeVariantsInUse.has(variantId)) {
        console.log(
          `%c REMOVE orphaned fee item %c${variantId}`,
          "background: #e53e3e; color: white; padding:2px 8px; border-radius:3px;",
          "background: #fff; color: #e53e3e;"
        );
        cartDebugReasons.push(`Remove orphaned fee item: ${variantId}`);
        await removeCartVariant(variantId);
        cartModified = true;
      }
    }

    const onlyFeeOrNoAdditionalFee = cartItems.every(item => {
      const hasAdditionalFee = !!(item.dataset.productAdditionalFee && item.dataset.productAdditionalFee !== "null");
      const hasCraftingFee = !!(item.dataset.productCraftingFee && item.dataset.productCraftingFee !== "null");
      const isFeeItem = item.dataset.isFee === 'true';
      return (!hasAdditionalFee && !hasCraftingFee) || isFeeItem;
    });
    console.log(
      `%c onlyFeeOrNoAdditionalFee ${onlyFeeOrNoAdditionalFee}`,
      "background:rgb(243, 0, 0); color: white; font-size: 14px; padding: 3px 12px; border-radius: 4px;"
    );

    if (!hasNonFeeProductWithFee || onlyFeeOrNoAdditionalFee) {
      console.log('case 2');
      for (const item of cartItems) {
        const isFeeItem = item.dataset.isFee === 'true';
        const variantId = extractVariantIdFromGID(item.dataset.variantGid);
        if (isFeeItem && feeVariantGIDs.has(variantId)) {
          console.log(
            `%c REMOVE fee item (case 2) %c${variantId}`,
            "background: #e53e3e; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #e53e3e;"
          );
          cartDebugReasons.push(`Remove fee (case2): ${variantId}`);
          await removeCartVariant(variantId);
          cartModified = true;
        }
      }
      if (cartModified) {
        console.log(
          "%c Cart updated because onlyFeeOrNoAdditionalFee or no product with fee.",
          "background: orange; color: white; font-size: 13px; padding: 2px 10px; border-radius: 3px;"
        );
        console.log("Debug reasons:", cartDebugReasons);
        
      }
    }

    // --- AGGREGATE ADDITIONAL FEES BY VARIANT ---
    const feeAggregation = {};
    cartItems.forEach(item => {
      if (item.dataset.productAdditionalFee && item.dataset.productAdditionalFee !== "null") {
        const additionalFee = JSON.parse(item.dataset.productAdditionalFee);
        const feeVariantId = extractVariantIdFromGID(additionalFee.fee_product_variant);
        if (!feeAggregation[feeVariantId]) {
          feeAggregation[feeVariantId] = {
            totalProductQty: 0,
            packageQty: parseFloat(additionalFee.package_quantity),
            feePerStep: parseFloat(additionalFee.fee),
            cap: parseFloat(additionalFee.fee_cap),
            feeVariantId: feeVariantId,
            capVariantId: extractVariantIdFromGID(additionalFee.fee_product_variant_cap_),
          };
        }
        feeAggregation[feeVariantId].totalProductQty += parseInt(item.dataset.quantity || "0");
      }
    });

    for (const feeVariantId in feeAggregation) {
      const agg = feeAggregation[feeVariantId];
      const numPackages = Math.ceil(agg.totalProductQty / agg.packageQty);
      const expectedFeeTotal = Math.min(numPackages * agg.feePerStep, agg.cap);

      const currentFeeQty = feeVariantInCart[feeVariantId]?.quantity || 0;
      const currentFeeCapQty = feeVariantInCart[agg.capVariantId]?.quantity || 0;

      if (expectedFeeTotal >= agg.cap) {
        if (currentFeeQty > 0) {
          console.log(
            `%c REMOVE regular fee item (cap reached) %c${feeVariantId}`,
            "background: #e53e3e; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #e53e3e;"
          );
          cartDebugReasons.push(`Remove regular fee (cap): ${feeVariantId}`);
          await removeCartVariant(feeVariantId);
          cartModified = true;
        }
        if (currentFeeCapQty === 0) {
          console.log(
            `%c ADD fee cap item %c${agg.capVariantId}`,
            "background: #38a169; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #38a169;"
          );
          cartDebugReasons.push(`Add fee cap: ${agg.capVariantId}`);
          await updateCartVariantQuantity(agg.capVariantId, 1, feeVariantInCart);
          cartModified = true;
        }
      } else {
        if (currentFeeCapQty > 0) {
          console.log(
            `%c REMOVE cap fee item (under cap) %c${agg.capVariantId}`,
            "background: #e53e3e; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #e53e3e;"
          );
          cartDebugReasons.push(`Remove fee cap (under cap): ${agg.capVariantId}`);
          await removeCartVariant(agg.capVariantId);
          cartModified = true;
        }
        const expectedQty = Math.ceil(expectedFeeTotal / agg.feePerStep);
        if (expectedQty !== currentFeeQty) {
          console.log(
            `%c UPDATE regular fee qty %c${feeVariantId} %c(expected: ${expectedQty}, current: ${currentFeeQty})`,
            "background: #3182ce; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #3182ce;",
            "color: #2d3748;"
          );
          cartDebugReasons.push(`Update fee qty: ${feeVariantId} expected: ${expectedQty}, current: ${currentFeeQty}`);
          await updateCartVariantQuantity(feeVariantId, expectedQty, feeVariantInCart);
          cartModified = true;
        }
      }
    }

    // --- Global Crafting Fee Aggregation (already global by variant) ---
    const craftingFeeMap = {};
    cartItems.forEach(item => {
      if (item.dataset.productCraftingFee && item.dataset.productCraftingFee !== "null") {
        const craftingFee = JSON.parse(item.dataset.productCraftingFee);
        const feeVariantId = extractVariantIdFromGID(craftingFee.fee_product_variant);
        const capVariantId = craftingFee.fee_product_variant_cap_
          ? extractVariantIdFromGID(craftingFee.fee_product_variant_cap_)
          : null;

        if (!craftingFeeMap[feeVariantId]) {
          craftingFeeMap[feeVariantId] = {
            totalProductQty: 0,
            packageQty: parseFloat(craftingFee.package_quantity),
            feePerUnit: parseFloat(craftingFee.fee),
            cap: craftingFee.fee_cap ? parseFloat(craftingFee.fee_cap) : null,
            feeVariantId,
            capVariantId,
          };
        }
        craftingFeeMap[feeVariantId].totalProductQty += parseInt(item.dataset.quantity || "0");
      }
    });

    for (const key in craftingFeeMap) {
      const {
        totalProductQty,
        packageQty,
        feePerUnit,
        cap,
        feeVariantId,
        capVariantId
      } = craftingFeeMap[key];

      const expectedPackages = Math.ceil(totalProductQty / packageQty);
      const expectedTotalFee = expectedPackages * feePerUnit;
      const currentQty = feeVariantInCart[feeVariantId]?.quantity || 0;
      const currentCapQty = capVariantId
        ? feeVariantInCart[capVariantId]?.quantity || 0
        : 0;
      const useCap = cap !== null && expectedTotalFee >= cap;

      if (useCap) {
        if (currentQty > 0) {
          console.log(
            `%c REMOVE crafting fee variant (cap reached) %c${feeVariantId}`,
            "background: #e53e3e; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #e53e3e;"
          );
          cartDebugReasons.push(`Remove crafting fee (cap): ${feeVariantId}`);
          await removeCartVariant(feeVariantId);
          cartModified = true;
        }
        if (capVariantId && currentCapQty === 0) {
          console.log(
            `%c ADD crafting fee cap variant %c${capVariantId}`,
            "background: #38a169; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #38a169;"
          );
          cartDebugReasons.push(`Add crafting fee cap: ${capVariantId}`);
          await updateCartVariantQuantity(capVariantId, 1, feeVariantInCart);
          cartModified = true;
        }
      } else {
        if (capVariantId && currentCapQty > 0) {
          console.log(
            `%c REMOVE crafting fee cap (under cap) %c${capVariantId}`,
            "background: #e53e3e; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #e53e3e;"
          );
          cartDebugReasons.push(`Remove crafting fee cap (under cap): ${capVariantId}`);
          await removeCartVariant(capVariantId);
          cartModified = true;
        }
        if (expectedPackages !== currentQty) {
          console.log(
            `%c UPDATE crafting fee qty %c${feeVariantId} %c(expected: ${expectedPackages}, current: ${currentQty})`,
            "background: #3182ce; color: white; padding:2px 8px; border-radius:3px;",
            "background: #fff; color: #3182ce;",
            "color: #2d3748;"
          );
          cartDebugReasons.push(`Update crafting fee qty: ${feeVariantId} expected: ${expectedPackages}, current: ${currentQty}`);
          await updateCartVariantQuantity(feeVariantId, expectedPackages, feeVariantInCart);
          cartModified = true;
        }
      }
    }

    // Show expected cart JSON for debugging
    const expectedCartJSON = cartItems.map(item => ({
      variantId: extractVariantIdFromGID(item.dataset.variantGid),
      quantity: parseInt(item.dataset.quantity || "0"),
      additionalFee: item.dataset.productAdditionalFee ? JSON.parse(item.dataset.productAdditionalFee) : null,
      craftingFee: item.dataset.productCraftingFee ? JSON.parse(item.dataset.productCraftingFee) : null,
      isFee: item.dataset.isFee
    }));

    console.log(
      '%c Expected cart state JSON (before update):',
      "background: #fbbf24; color: #1f2937; font-size: 13px; padding: 2px 10px; border-radius: 3px;"
    );
    console.log(expectedCartJSON);
    console.log(
      "%c Cart is being updated due to the above reasons:",
      "background: orange; color: white; font-size: 13px; padding: 2px 10px; border-radius: 3px;"
    );
    console.log("Debug reasons:", cartDebugReasons);

    // Update DOM dynamically (selector: cart-items)
    const updatedCart = await fetch(`${routes.cart_url}?section_id=main-cart-items`);
    const updatedText = await updatedCart.text();
    const updatedHtml = new DOMParser().parseFromString(updatedText, 'text/html');
    const newCartSection = updatedHtml.querySelector('cart-items');
    if (newCartSection) {
      const existingCartSection = document.querySelector('cart-items');
      if (existingCartSection && newCartSection) {
        existingCartSection.innerHTML = newCartSection.innerHTML;
      }

    }
    
    // Debug final cart state
    const finalCartItems = Array.from(newCartSection.querySelectorAll('.cart-item'));
    const finalCartJSON = finalCartItems.map(item => ({
      variantId: extractVariantIdFromGID(item.dataset.variantGid),
      quantity: parseInt(item.dataset.quantity || "0"),
      additionalFee: item.dataset.productAdditionalFee ? JSON.parse(item.dataset.productAdditionalFee) : null,
      craftingFee: item.dataset.productCraftingFee ? JSON.parse(item.dataset.productCraftingFee) : null,
      isFee: item.dataset.isFee
    }));

    console.log('%c Final cart state JSON (after update):', "background: #34d399; color: #111; font-size: 13px; padding: 2px 10px; border-radius: 3px;");
    console.log(finalCartJSON);

    // Compare and log differences
    const diffs = compareCartJSON(expectedCartJSON, finalCartJSON);
    if (diffs.length) {
      console.log('%c Differences between expected and final cart:', "background: #f87171; color: #fff; font-size: 13px; padding: 2px 10px; border-radius: 3px;");
      console.log(diffs);
      publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', line: event?.line },);
    } else {
      console.log('%c No differences between expected and final cart.', "background: #22d3ee; color: #111; font-size: 13px; padding: 2px 10px; border-radius: 3px;");
    }
    if (cartModified) {
    }
    if (cartItemsEl && typeof cartItemsEl.disableLoading === 'function') {
      if(event?.line) {
        cartItemsEl.disableLoading(event.line);
      } else {
        cartItemsEl.disableLoading(1);
      }
    }
  };

  onCartUpdate();
});
